import React, { Component } from 'react';
import LocalesProvider from './Providers/LocalesProvider.js';
import WebServiceProvider from './Providers/WebServiceProvider.js';
import { WebServiceContextConsumer } from './Providers/WebServiceProvider.js';

import { AbilityContext } from './abilities-context'
import ability from './abilities'

class ApplicationContainer extends Component
{
	render() {
		return (
			<AbilityContext.Provider value={ability}>
				<WebServiceProvider>
					<WebServiceContextConsumer>
						{ 
							context =>
								<LocalesProvider {...context}>
									{this.props.children}
								</LocalesProvider>
						}
					</WebServiceContextConsumer>
				</WebServiceProvider>
			</AbilityContext.Provider>
		);
	}
}

export default ApplicationContainer;


// WEBPACK FOOTER //
// ./src/ApplicationContainer.js